<template>
    <!-- initial questions -->
    <LcForm v-if="this.showInitialQuestions"
        :formData="this.formData.initial"
        v-model:application-settings="this.applicationSettings"
        @completed.once="this.userSelectedOption = true"
    />
    
    <!-- EID Component -->
    <!-- Here is where getQuiz and getVerifed happens -->
    <UserVerification v-if="this.showVerificationComponent"
        v-model:application-settings="this.applicationSettings"
        @completed.once="this.applicationSettings.isUserVerified = true"
    />

    <!-- verified state -->
    <LcForm v-if="this.showVerifiedStateFlow"
        :formData="this.formData.verified"
        :formSettings="this.formSettings"
        v-model:application-settings="this.applicationSettings"
        @completed.once="this.componentSettings.isCompleted = true"
    />

    <!-- unverified state -->
    <LcForm v-if="this.showUnverifiedStateFlow"
        :formData="this.formData.unverified"
        :formSettings="this.formSettings"
        v-model:application-settings="this.applicationSettings"
        @completed.once="this.componentSettings.isCompleted = true"
    />
</template>

<script>

import LcForm from '@/components/form/LcForm.vue';
import UserVerification from '@/components/UserVerification.vue';

import formSteps from '@/form/steps/verification.js';
import formStepsVerified from '@/form/steps/verified.js';
import formStepsUnverified from '@/form/steps/unverified.js';

import { inject } from 'vue';

export default {
    name: 'VerificationFlow',
    emits: ["update:application-settings","update:component-settings"],
    setup(props) {
        const { app, updateApplication } = inject('app'); // app is being provided in Application.vue
        return {
            app,
            updateApplication
        }
    },
    components: {
        LcForm,
        UserVerification,
    },
    props: {
        applicationSettings: {
            type: Object,
            required: true,
        },
        componentSettings: {
            type: Object,
            required: true,
        },
        skipVerification: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data: () => {

        let userSelectedOption = false;

        const formData = {
            initial: {
                steps: formSteps
            },
            verified: {
                steps: formStepsVerified
            },
            unverified: {
                steps: formStepsUnverified
            }
        };

        const formSettings = {
            submitButtonText: 'Submit'
        };

        return {
            formData,
            formSettings,
            userSelectedOption
        };
    },
    methods: {
        shouldSkipVerification() {
            if(this.skipVerification) {
                this.userSelectedOption = true;
                this.applicationSettings.userWantsVerification = false;
                this.applicationSettings.isUserVerified = false;
            }
        }
    },
    computed: {
        showInitialQuestions() {
            return !this.userSelectedOption;
        },
        showVerificationComponent() {
            return !this.applicationSettings.isUserVerified && !!this.applicationSettings.userWantsVerification;
        },
        showVerifiedStateFlow() {
            return !!this.userSelectedOption && !!this.applicationSettings.isUserVerified;
        },
        showUnverifiedStateFlow() {
            return !!this.userSelectedOption && !this.applicationSettings.isUserVerified && !this.applicationSettings.userWantsVerification;
        },

    },
    created() {
        // console.log('VerificationFlow created');
        if( !this.applicationSettings.isUserAuthenticated ) {
            this.applicationSettings.userSkippedAuthentication = true;
        }
        this.userSelectedOption = !!this.applicationSettings.isUserVerified;
    },
    mounted() {
        // console.log('VerificationFlow mounted');
        this.shouldSkipVerification();
    },
    watch: {
    }  

};
</script>